import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type JDToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
};

export function JDToolbar({ canManage, onCreate }: JDToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="font-bold text-2xl tracking-tight">ຄຳອະທິບາຍຕໍາແໜ່ງ</h2>
          <p className="text-muted-foreground">ຈັດການຄຳອະທິບາຍຕໍາແໜ່ງ (JD).</p>
        </div>
        {canManage && (
          <div className="flex items-center space-x-2">
            <Button onClick={onCreate}>
              <PlusIcon className="h-4 w-4" />
              ສ້າງ JD ໃໝ່
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
